<script setup lang="ts">
definePageMeta({ middleware: 'marketing' });

useHead({
  title: 'Terms of Use',
  meta: [
    {
      name: 'description',
      content: 'Terms of Use',
    },
  ],
});

onMounted(() => {
  /* eslint-disable */
  if (process.browser) {
    (function (d, s, id) {
      let js;
      const tjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://app.termly.io/embed-policy.min.js';
      tjs.parentNode.insertBefore(js, tjs);
    })(document, 'script', 'termly-jssdk');
  }
  /* eslint-enable */
});
</script>

<template>
  <div class="bg-gray-100">
    <client-only>
      <container>
        <div
          name="termly-embed"
          data-id="1e9f8bf9-95ea-43f9-9bc1-f2a7df5f5dce"
          data-type="iframe"
        />
      </container>
    </client-only>
  </div>
</template>
